<template>
	<el-dialog
		:title="routeName"
		v-if="dialogVisible"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:modal-append-to-body="false"
		width="500px"
	>
		<div class="tc">
			<el-select ref="myselect" v-model="routeColor" @change="handleChange" placeholder="请选择路线颜色">
				<el-option
					v-for="item in color_list"
					:key="item"
					:label="item"
					:value="item">
					<span class="color-span" :style="`background-color:${item};`">{{ item }}</span>
				</el-option>
			</el-select>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="medium" @click="dialogVisible = false">取 消</el-button>
			<el-button size="medium" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			routeColor: '',
			// 颜色列表
			color_list: [
				"#ff2121",
				"#4b5cc4",
				"#00bc12",
				"#801dae",
				"#fa8c35",
				"#ff0097",
				"#75878a",
				"#2edfa3",
				"#cca4e3",
				"#eacd76"
			],
			routeId: '',
			routeName: ''
		};
	},
	methods: {
		init(route) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.routeColor = route.color;
				this.routeId = route.routeId;
				this.routeName = route.routeName;
				setTimeout(() => {
					this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.backgroundColor = this.routeColor;
					this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.borderColor = this.routeColor;
					this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.color = '#fff';
				}, 300);
			});
		},
		handleChange() {
			// 修改input框式样
			this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.backgroundColor = this.routeColor;
			this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.borderColor = this.routeColor;
			this.$refs.myselect.$el.querySelectorAll('.el-input__inner')[0].style.color = '#fff';
		},
		// 点击确定
		handleSubmit() {
			this.$request
				.post("routeMapAddColor", false, {
					routeId: this.routeId,
					color: this.routeColor
				})
				.then(res => {
					if(res.code == '0') {
						this.$emit('routeInfoList');
						this.dialogVisible = false;
					}
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.color-span{
	display: block;
	width: 100%;
	text-align: center;
	color: #fff;
	font-size: 14px；
}
.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}
.el-select-dropdown__item{
	padding: 4px;
	height: 44px;
}
</style>
